enum ItemType {
    Repository = 'REPOSITORY',
    Module = 'MODULE',
    Library = 'LIBRARY',
    Bug = 'BUG',
}

export default ItemType;